module.exports = __webpack_public_path__ + "static/media/faq_(5).5cfc1039.gif";